import flow from "lodash/flow";
import lowerCase from "lodash/lowerCase";
import startCase from "lodash/startCase";

export const titleCase = flow(lowerCase, startCase);
